export default __webpack_public_path__ + "static/media/Support.c20442de.svg";